$(document).ready(function() {
  console.log('123');
  $(".fitting-guide").fancybox({
    content : $('.hat-size-fit').html()
  });


$('#customer_login .submit-button').on('click',function(e){ 
  $.ajax({ 
    type: "POST", 
    url: '/cart/clear.js', 
    success: function(){ 
    }, dataType: 'json' 
  }); 
})

// click image of coresponding option. setTimeout to query last
function selectViewportImage(imgSrc) {
  const galleryPath = $('.product-gallery--navigation');
  setTimeout(function() {
    const imageElement = galleryPath.find(`[data-info*="${imgSrc}"]`);
    if (imageElement.length) {
      imageElement.trigger('click');
    }
  }, 0);
}


// define option switch
$('.option-value-input').click(function() {
  const $this = $(this);
  const optionName = $this.attr('data-product-option') !== 'option1'
    ? $('.option-value-input[data-product-option="option1"]:checked').val()
    : $this.val();
    
  console.log('check OptionName ' + optionName);

  const imageOptions = {
    'Standard Notch': ['-4.jpg', 'products/Standard-Notch', 'files/StandardNotchLocation', 'products/StandardNotch', 'files/Standard-Notch'],
    'Terra/Aviator Notch': ['-5.jpg', 'products/Terra-Notch', 'products/TerraNotch', 'files/TerraNotchLocation', 'files/Terra-Notch'],
    'Notch-less': ['products/Notch-Less', 'files/Notch-LessLocation', 'files/Notch-Less']
  };

  if (imageOptions[optionName]) {
    imageOptions[optionName].forEach(selectViewportImage);
  }
});
  
});

// Update Error Messsage Text

$(document).ajaxComplete(function(){
  if($('.error-message').html() == 'Required parameter missing or invalid: items'){
  	$('.error-message').html('Not Available for Wholesale Accounts');
  }
});

